import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styles: ``,
  standalone: false
})
export class CookiePolicyComponent implements OnInit {
  accepted = true
  ngOnInit(): void {
    this.accepted = localStorage.getItem('cookie') == 'true'
  }

  acceptCookie(){
    localStorage.setItem('cookie','true')
    this.accepted = true
  }

  refuseCookie(){
    localStorage.setItem('cookie','false')
    window.location.replace('https://www.google.com')
  }
}

